<!-- 新品价弹窗 -->
<template>
  <div class="popup-wrapper" :class="{ 'no-main-pic': !newPriceExplain.modelPic }">
    <z-popup v-model="newpricePopupShow" position="bottom">
      <div class="new-price-popup" v-zpm="{ sectionid: 105 }">
        <div
          class="new-price-popup-icon"
          @click="newpricePopupShow = false"
          v-zpm="{ sortid: 15, sortname: '新机价半层-关闭' }"
        >
          <img
            src="https://pic4.zhuanstatic.com/zhuanzh/d3e99a56-a5c1-4600-92fc-75ade87d7081.png"
            alt=""
          />
        </div>

        <div class="popup-content">
          <div v-if="newPriceExplain.modelPic" class="main-img">
            <img :src="$setPicSize(newPriceExplain.modelPic, 520, 520)" alt="" />
          </div>
          <div
            class="price-wrapper"
            :class="{ 'price-wrapper-android': getSysType() == 'android' }"
          >
            <em>¥</em>
            <span class="price">{{ newPriceExplain.newPriceCent / 100 }}</span>
            <span class="price-desc">{{ newPriceExplain.newPriceExplainText }}</span>
          </div>
          <span class="price-tips"> {{ newPriceExplain.priceExplainText }} </span>
          <span class="goods-title">{{ newPriceExplain.externalTitle }} </span>
          <div class="price-intro">
            <span class="price-update">{{ newPriceExplain.updateTime }}</span>
            <span
              v-if="newPriceExplain.externalLink"
              class="price-reference"
              @click="gotoJD"
              v-zpm="{ sortid: 13, sortname: '新机价半层-去看看' }"
              >去看看
              <img
                src="https://pic1.zhuanstatic.com/zhuanzh/a2e5f522-bb31-4c8c-b2d8-91ac67f58a66.png"
                alt=""
              />
            </span>
          </div>

          <div class="price-tips-wrapper">
            <div class="tips-header">
              <span class="tips-icon">Tips</span>
              <span class="title">参考价说明</span>
            </div>
            <span v-if="newPriceExplain.debutPriceText" class="common-desc">
              <span class="common-desc-title">发售价:</span>
              {{ newPriceExplain.debutPriceText }}
            </span>
            <span v-if="newPriceExplain.newPriceText" class="common-desc">
              <span class="common-desc-title">新品价:</span>
              {{ newPriceExplain.newPriceText }}
            </span>
            <span class="common-desc">
              <span class="common-desc-title">折扣:</span>
              该商品到手价 ÷ 发售价
            </span>
          </div>
        </div>

        <div
          class="footer-icon"
          @click="newpricePopupShow = false"
          v-zpm="{ sortid: 14, sortname: '新机价半层-我知道了' }"
        >
          我知道了
        </div>
      </div>
    </z-popup>
    <z-dialog
      v-model="showDialog"
      :overlay="true"
      title="商品链接已复制"
      confirmButtonText="我知道了"
    >
      <div class="dialog-content">
        <span class="title">您可前往浏览器粘贴网址查看</span>
        <span class="link">{{ newPriceExplain.externalLink }}</span>
      </div>
    </z-dialog>
  </div>
</template>

<script>
import { Popup, Dialog } from '@zz-common/zz-ui'
import Vue from 'vue'
import copy from '@utils/copy.js'
import { defineComponent, watch, ref } from '@vue/composition-api'
import { getSysType } from '@utils/ua'
Vue.use(Popup).use(Dialog)

export default defineComponent({
  props: {
    newPriceExplain: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, ctx) {
    const { $legoSend } = ctx.root
    const newpricePopupShow = ref(false)
    const showDialog = ref(false)
    watch(
      () => newpricePopupShow.value,
      (val) => {
        if (val) {
          $legoSend({
            pagetype: 'Areaexposure',
            actiontype: 'T2974',
            backup: {
              sectionId: 144
            }
          })
        }
      }
    )

    const gotoJD = () => {
      copy(props.newPriceExplain.externalLink).then(() => {
        showDialog.value = true
      })
    }
    return { newpricePopupShow, gotoJD, showDialog, getSysType }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.popup-wrapper {
  /deep/ .z-popup--bottom {
    box-sizing: border-box;
    height: 80%;
  }
  &.no-main-pic {
    /deep/ .z-popup--bottom {
      height: 50%;
    }
  }
}

/deep/ .z-iphone-x {
  padding-bottom: 0 !important;
}

.popup-content {
  height: calc(100% - 156px - env(safe-area-inset-bottom));
  padding: 0 32px;
  overflow-y: scroll;
}
.new-price-popup {
  position: relative;
  height: 100%;
  // padding: 0 32px;
  padding-top: 32px;

  &-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin-top: 24px;
    margin-right: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .main-img {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 520px;

    img {
      width: 520px;
      height: 520px;
    }
  }
  .price-wrapper {
    display: flex;
    align-items: flex-end;
    margin-top: 24px;
    color: #111111;

    &.price-wrapper-android {
      em {
        position: relative;
        top: -3px;
      }
      .price {
        line-height: 48px;
      }
    }
    em {
      font-weight: 800;
      font-size: 36px;
      font-family: Avenir-Heavy, Avenir;
      line-height: 36px;
    }
    .price {
      margin-left: 4px;
      font-weight: 500;
      font-size: 64px;
      font-family: Akrobat-ExtraBold, Akrobat;
      line-height: 54px;
    }
    .price-desc {
      margin-left: 8px;
      font-weight: 300;
      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
    }
  }
  .price-tips {
    display: inline-block;
    margin-top: 12px;
    color: #999999;
    font-weight: 300;
    font-size: 22px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 22px;
  }
  .goods-title {
    @include overflowLine(2);
    margin-top: 16px;
    color: #111111;
    font-weight: 400;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 42px;
  }
  .price-intro {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    color: #999999;
    font-weight: 300;
    font-size: 22px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 22px;
    .price-update {
      color: #999999;
      font-weight: 300;
      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 22px;
    }
    .price-reference {
      display: flex;
      align-items: center;
      font-size: 22px;
      img {
        width: 10px;
        height: 16px;
        margin-left: 10px;
      }
    }
  }
  .price-tips-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 210px;
    margin-top: 40px;
    padding-left: 32px;
    background: #fafafa;
    border-radius: 16px;
    .tips-header {
      display: flex;
      .tips-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 28px;
        color: #111111;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 28px;
        line-height: 20px;
        text-align: center;
        background: linear-gradient(160deg, #f7deff 0%, #ddfeff 100%);
        border-radius: 4px;
      }
      .title {
        margin-left: 12px;
        color: #111111;
        font-weight: 400;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    .common-desc {
      margin-top: 16px;
      color: #666666;
      font-weight: 300;
      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 24px;
    }
  }
  .footer-icon {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 702px;
    height: 80px;
    margin-bottom: calc(56px + env(safe-area-inset-bottom));
    margin-left: -351px;
    color: #ffffff;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 80px;
    text-align: center;
    background: #ff483c;

    border-radius: 40px;
  }
}

.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
  .title {
    color: #111111;
    font-weight: 400;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 44px;
  }
  .link {
    margin-top: 12px;
    color: #666666;
    font-weight: 300;
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 34px;
  }
}
</style>
